// Exemplo: converter segundos em formato hh:mm:ss ou mm:ss
export function formatarTempo(segundos) {
  const h = Math.floor(segundos / 3600); // horas
  const m = Math.floor((segundos % 3600) / 60); // minutos restantes
  const s = Math.floor(segundos % 60); // segundos restantes

  const hh = h > 0 ? String(h).padStart(1, '0') + ':' : ''; // só mostra horas se >0
  const mm = String(m).padStart(2, '0'); // sempre 2 dígitos
  const ss = String(s).padStart(2, '0'); // sempre 2 dígitos

  return hh + mm + ':' + ss;
}
export function encontrarVideo(videoId,videos) {
  for(let video of videos){
    if(video.id==videoId)return video
  }
  return null
}